import { createContext } from 'react';

export const NavDrawerContext = createContext('');
